export default (initialState = {}) => {
  return () => {
    return {
      amount: "",
      amount_wt: "",
      cess: 0,
      gst: 0,
      hsn: 0,
      item_id: null,
      is_tax_included: false,
      margin_expectation: null,
      name: "",
      rate: undefined,
      rate_wt: undefined,
      qty: undefined,
      unit: "Units",
      ...initialState,
    };
  };
};
